<script lang="ts">
    import { faAngleLeft, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, get_current_component, onMount } from 'svelte/internal'
    import { AudienceRule } from '../../../modules/eventsApi/audienceRules/audience-rule'
    import { Audience } from '../../../modules/eventsApi/audiences/audience'
    import type { AudienceCreateDto } from '../../../modules/eventsApi/audiences/dto/audience-create.dto'
    import type { AudienceUpdateDto } from '../../../modules/eventsApi/audiences/dto/audience-update.dto'
    import { AudiencesRepository } from '../../../modules/eventsApi/audiences/audiences.repository'
    import { AudiencesService } from '../../../modules/eventsApi/audiences/audiences.service'
    import PublicoRegra from './audience-regra.svelte'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import AudienceFileImport from './audience-file-import.svelte'
    import type { CreateStaticAudienceDto } from '../../../modules/eventsApi/audiences/dto/create-static-audience.dto'
    import dayjs from 'dayjs'
    import type { AutomationSourceEnum } from '../../../modules/automationApi/automations/automation-source.enum'
    import AudienceShow from './audience-show.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import ZsheetSection from '../../_common/z/sheet/zsheet-section.svelte'
    import ZsheetAdd from '../../_common/z/sheet/zsheet-add.svelte'
    const dispatch = createEventDispatcher()

    const rep = new AudiencesRepository()
    const service = new AudiencesService(rep)
    const me = get_current_component()

    export let form: boolean = false
    export let type: string = null
    export let audienceId: string = null
    export let source: AutomationSourceEnum = null

    let show = false
    let step = 1
    let entities: Audience[] = []
    let entity: Audience = new Audience()

    let showTypes = false
    let audienceTypes = [
        { label: 'Estático', value: 'static' },
        { label: 'Dinâmico', value: 'dynamic' },
    ]

    let csvData = []
    let csvTypes = []
    csvTypes.push({ value: 'externalId', label: 'ID' })
    csvTypes.push({ value: 'name', label: 'Nome' })
    csvTypes.push({ value: 'phone', label: 'Telefone' })
    csvTypes.push({ value: 'email', label: 'E-Mail' })
    csvTypes.push({ value: 'document', label: 'CPF ou CNPJ' })
    csvTypes.push({ value: 'born', label: 'Nascimento' })
    csvTypes.push({ value: 'createdAt', label: 'Data inclusão' })
    // Endereço vem depois do resto e com prefixo no rótulo: são sete opções seguidas, e sem o prefixo
    // elas se perderiam no meio da lista. O valor é o nome do campo da pessoa (Person.CEP, Person.district…),
    // porque é ele que vira a chave do dado importado.
    csvTypes.push({ value: 'CEP', label: 'Endereço - CEP' })
    csvTypes.push({ value: 'address', label: 'Endereço - Rua' })
    csvTypes.push({ value: 'number', label: 'Endereço - Número' })
    csvTypes.push({ value: 'complement', label: 'Endereço - Complemento' })
    csvTypes.push({ value: 'district', label: 'Endereço - Bairro' })
    csvTypes.push({ value: 'city', label: 'Endereço - Cidade' })
    csvTypes.push({ value: 'state', label: 'Endereço - UF' })
    csvTypes.push({ value: '-', label: 'Outro / Não importar' })

    onMount(async () => {
        if (form) {
            if (audienceId) {
                await editEntity(audienceId)
            } else {
                newEntity()
            }
        } else {
            await loadEntities()
        }
    })

    async function loadEntities() {
        try {
            show = true
            entities = []
            entities = await service.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function editEntity(id: string) {
        try {
            newImport = false
            show = true
            entity = new Audience()
            entity = await service.getOne(id, { rules: true })
            console.log('audience', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        newImport = false
        allowDuplicity = false
        allowDuplicateNames = false
        entity = new Audience()
        if (type) {
            entity.type = type
            showTypes = false
        } else {
            showTypes = true
            entity.type = ''
        }
        step = 2
    }

    async function saveEntity() {
        if (entity.audienceId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function createEntity() {
        try {
            show = true
            const dto: AudienceCreateDto = {
                type: entity.type,
                title: entity.title,
            }
            entity = await service.create(dto)
            audienceId = entity.audienceId
            // if (form) {
            //     sendClose()
            //     return
            // }
            await loadEntities()
            await editEntity(entity.audienceId)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            const dto: AudienceUpdateDto = {
                title: entity.title,
            }
            await service.update(entity.audienceId, dto)
            if (newImport) {
                await saveImport()
            }
            audienceId = entity.audienceId
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function adjustDates(csv, field) {
        let month = 0
        let day = 0
        let year = 0
        let limiter = ''
        for (const person of csv) {
            let parts = []
            if (person[field] && person[field].length >= 6) {
                if (person[field].includes('-')) {
                    limiter = '-'
                    year = 0
                    month = 1
                    day = 2
                    break
                }
                parts = person[field].split('/')
                if (parts.length > 0) {
                    limiter = '/'
                    if (parseInt(parts[0]) > 12) {
                        year = 2
                        month = 1
                        day = 0
                        break
                    }
                    if (parseInt(parts[1]) > 12) {
                        year = 2
                        month = 0
                        day = 1
                        break
                    }
                }
            }
        }
        for (let person of csv) {
            if (!limiter || !person[field] || person[field].length < 6) {
                person[field] = undefined
                continue
            }
            let parts = person[field].split(limiter)
            let tempDate = parts[year] + '-' + parts[month] + '-' + parts[day]
            let utcBorn = null
            try {
                utcBorn = dayjs(window.api.utils.utils.dateStringToCurrentDate(tempDate)).toISOString()
                person[field] = utcBorn
            } catch (error) {
                console.log('adjustDates_error', error)
                person[field] = null
            }
        }
        return csv
    }

    async function saveImport() {
        if (!validImport) {
            throw new Error('Todos os campos devem ser preenchidos')
        }
        if (csvData.length > 10000) {
            throw new Error(
                'ATENÇÃO: O limite máximo de registros em um arquivo é de 5000 contatos. Seu arquivo possui ' +
                    csvData.length +
                    '.\n Divida o arquivo em partes menores caso queira importar uma quantidade maior.',
            )
        }
        let dto: CreateStaticAudienceDto = {
            audienceId: entity.audienceId,
            persons: [],
            allowDuplicates: allowDuplicity,
            allowUpdateNames: allowDuplicateNames,
        }
        // adjust born date
        csvData = adjustDates(csvData, 'born')
        csvData = adjustDates(csvData, 'createdAt')
        for (const person of csvData) {
            if (person.phone) {
                dto.persons.push({
                    name: person.name,
                    externalId: person.externalId,
                    phone: person.phone,
                    email: person.email,
                    document: person.document,
                    CEP: person.CEP,
                    address: person.address,
                    number: person.number,
                    complement: person.complement,
                    district: person.district,
                    city: person.city,
                    state: person.state,
                    born: person.born ? new Date(person.born) : undefined,
                    createdAt: person.createdAt ? new Date(person.createdAt) : undefined,
                })
            }
        }
        if (dto.persons.length > 0) {
            await service.createStaticAudience(dto)
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await service.remove(entity.audienceId)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let emptyRule: AudienceRule
    let newRule: boolean = false
    function newListItem() {
        emptyRule = new AudienceRule()
        emptyRule.audienceId = entity.audienceId
        emptyRule.lastEvent = true
        newRule = true
    }

    let validImport: boolean
    let newImport: boolean = false
    function showFileImport() {
        newImport = true
    }

    async function newRuleSuccess() {
        newRule = false
        try {
            show = true
            await service.generateAudience(entity.audienceId)
            await editEntity(entity.audienceId)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newRuleCancel() {
        newRule = false
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
        if (form) dispatch('close', {})
    }

    function showAudience(_audienceId) {
        audienceId = _audienceId
        step = 3
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Públicos'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Nome do público' }))
        grid.cols.push(new GridCol({ content: 'Tipo', size: 1 }))
        grid.cols.push(new GridCol({ content: 'Criação', type: GridColTypeEnum.datetime, class: 'fix-w_170' }))
        grid.cols.push(new GridCol({ content: 'Última atualização', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Próxima atualização', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.string }))
        grid.cols.push(new GridCol({ content: 'Audiência', size: 1 }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let btnShow = new GridButton({
                callback: () => showAudience(item.audienceId),
                label: 'Ver',
            })
            let btnEdit = new GridButton({
                callback: () => editEntity(item.audienceId),
                label: 'Editar',
            })

            let line: GridLine = new GridLine()
            line.slots.push({ content: item.title })
            line.slots.push({ content: item.type === 'static' ? 'Estático' : 'Dinâmico' })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.lastUpdate })
            line.slots.push({ content: item.nextUpdate })
            line.slots.push({ content: item.stage })
            line.slots.push({ content: item.totalDistinct + ' pessoas' })
            line.slots.push({ content: [btnShow, btnEdit] })
            grid.lines.push(line)
        }
    }

    let allowDuplicity: boolean = false
    let allowDuplicateNames: boolean = false

    function toggleDuplicity() {
        console.log('toggleDuplicity', allowDuplicity)
    }
</script>

<Content footer={true}>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.marketing.audience.write}
                <Zbutton color="primary" icon={faPlusCircle} label="Novo público" on:click={newEntity} />
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
    {/if}

    {#if step === 2}
        <Zact>
            <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
            <div class="spacer" />
            {#if entity.audienceId}
                <Zbutton color="red" icon={faTrashAlt} label="Excluir" on:click={removeEntity} />
                <Zbutton color="primary" icon={faSave} label="Salvar" disabled={show} on:click={saveEntity} />
            {/if}
        </Zact>

        <div class="sections">
            <ZsheetSection label="Público" meta={entity.title ? '' : 'obrigatório'}>
                <ZContainer gapRow="8px" gapCol="8px">
                    {#if showTypes}
                        <!-- estático é uma lista de pessoas; dinâmico é um conjunto de regras que o
                             sistema reavalia. O tipo não muda depois de criado -->
                        <Zinput size={3} sizeM={12} label="Tipo de público" type="select" options={audienceTypes} bind:value={entity.type} />
                    {/if}
                    <Zinput size={showTypes ? 6 : 9} sizeM={12} label="Nome do público" type="text" bind:value={entity.title} />
                    {#if !entity.audienceId}
                        <ZContainerCol size={3} sizeM={12} flex={true}>
                            <Zbutton grow={true} color="primary" icon={faSave} label="Criar" disabled={show} on:click={saveEntity} />
                        </ZContainerCol>
                    {/if}
                </ZContainer>
            </ZsheetSection>

            {#if entity?.audienceId}
                <!-- as regras não ficam dentro de um cartão: cada uma já desenha o próprio conector e o
                     próprio bloco, e um cartão em volta vira cartão dentro de cartão. É a mesma estrutura
                     dos atos do editor de automação, que aparecem soltos abaixo dos blocos de campos. -->
                <div class="regras">
                    {#if Array.isArray(entity?.audienceRules)}
                        {#each entity.audienceRules as rule, i}
                            <PublicoRegra {source} firstRule={i === 0} {rule} type={entity.type} on:change={newRuleSuccess} on:cancel={newRuleCancel} />
                        {/each}
                    {/if}

                    {#if newRule}
                        <PublicoRegra
                            firstRule={entity.audienceRules.length === 0}
                            type={entity.type}
                            rule={emptyRule}
                            on:change={newRuleSuccess}
                            on:cancel={newRuleCancel}
                        />
                    {:else if newImport}
                        <!-- a importação é um formulário, então continua num bloco próprio -->
                        <ZsheetSection label="Importar pessoas">
                            <ZContainer gapRow="8px" gapCol="8px">
                                <Zinput
                                    size={6}
                                    sizeM={12}
                                    type="toggle"
                                    bind:value={allowDuplicity}
                                    on:change={toggleDuplicity}
                                    label="Permitir duplicidade de telefones"
                                    help="Duplicidades serão aceitas APENAS se o NOME da pessoa for diferente."
                                />
                                <Zinput
                                    size={6}
                                    sizeM={12}
                                    type="toggle"
                                    bind:value={allowDuplicateNames}
                                    label="Atualizar nomes de contatos existentes"
                                    help="Caso a pessoa já exista na base de contatos, atualizar o nome dela com o nome presente no arquivo de importação."
                                />
                            </ZContainer>
                            <div class="importador">
                                <AudienceFileImport types={csvTypes} bind:data={csvData} bind:valid={validImport} />
                            </div>
                        </ZsheetSection>
                    {:else if entity?.type === 'static'}
                        <ZsheetAdd label="Importar um arquivo" on:click={showFileImport} />
                    {:else}
                        <ZsheetAdd label="Regra" on:click={newListItem} />
                    {/if}
                </div>
            {/if}
        </div>
    {/if}

    {#if step === 3}
        <AudienceShow on:close={showEntities} {audienceId} />
    {/if}
</Content>
<LoadSpinner {show} />

<style>
    /* pilha de blocos, a mesma das outras telas modernizadas */
    .sections {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin: 12px 0px 48px 0px;
    }
    .regras {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    /* o importador desenha a própria área de arrastar arquivo */
    .importador {
        margin-top: 12px;
    }
</style>
